import { connect } from "react-redux";
import { cancelDeal } from "actions/deal";
import { closeModal } from "actions/modals";

import DealCancelModal from "./DealCancelModal";

const mapDispatchToProps = (dispatch, { dealID }) => ({
  onSubmit: (cancelFeedback) =>
    dispatch(cancelDeal(dealID, cancelFeedback)).then(() =>
      dispatch(closeModal("DealCancelModal"))
    ),
});

export default connect(null, mapDispatchToProps)(DealCancelModal);
